import { render, staticRenderFns } from "./SmsButon.vue?vue&type=template&id=7fab8414&"
import script from "./SmsButon.vue?vue&type=script&lang=js&"
export * from "./SmsButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports